import { useEffect, useRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Swiper, { Pagination } from 'swiper';

const Img = ({ prod, className, suffix, lnkClassName }) => {
  const galElt = useRef(null);
  const pagElt = useRef(null);


  const { id, imgs, link, name } = prod;

  const lnkClass = lnkClassName || 'category-cart__photo';
  const swiperClass = className || 'category-cart__slid';

  useEffect(() => {
    if (galElt === null || pagElt === null) {
      return;
    }
    const swiper = new Swiper(galElt.current, {
      modules: [Pagination],
      pagination: {
        el: pagElt.current,
        clickable: true,
      },
    });

    swiper.on('slideChange', () => {
      swiper.pagination.render();
      swiper.pagination.update();
    });
  }, []);

  return (
    <>
      <div className={`swiper ${swiperClass}`} ref={galElt}>
        <div className="swiper-wrapper">
          {imgs.map((img, idx) => {
            const key = `${id}-${idx}`;
            return (
              <div className="swiper-slide" key={key}>
                <a href={link} className={lnkClass}>
                  <LazyLoadImage
                    src={img}
                    placeholder={<div className='swiper-slide placeholder' />}
                    alt={`${name}, фото ${idx + 1}`}
                  />
                </a>
              </div>
            );
          })}
        </div>
        <div ref={pagElt} className="swiper-pagination" />
      </div>
    </>
  );
};

export default Img;
